import update from 'immutability-helper';

import { pendingAction, rejectedAction } from 'framework-ui-components/Components/Redux/reducerHelper';
import typeToReducer from 'type-to-reducer';
import { setValue as setPreferenza } from '../utils/salvataggioPreferenze';
import { dichiarativiInitialState } from './initialState';

export default typeToReducer({
    ANNI_REGISTRATI_GET_PENDING: (state, action) => pendingAction(state, action, 'anniRegistrati'),
    ANNI_REGISTRATI_GET_REJECTED: (state, action) => rejectedAction(state, action, 'anniRegistrati'),
    ANNI_REGISTRATI_GET_FULFILLED: (state, action) => {
        const { payload } = action;

        const annoDefault = payload.find((x) => x.Default);

        return update(state, {
            anniRegistrati: { $merge: { data: payload } },
            annoSelezionato: { $set: annoDefault && annoDefault.Anno },
        });
    },
    ANNI_REGISTRATI_SET: (state, action) => {
        const { payload } = action;

        const annoDefault = payload.find((x) => x.Default);

        return update(state, {
            anniRegistrati: { $set: { data: payload } },
            annoSelezionato: { $set: annoDefault && annoDefault.Anno },
        });
    },
    ANNO_SELEZIONATO_SET: (state, action) => {
        const { payload } = action;

        setPreferenza('AnnoSelezionato', payload);

        return update(state, {
            annoSelezionato: { $set: payload },
        });
    },
}, dichiarativiInitialState);
